<template>
    <div
        class="sbs-stepper"
        :class="stepClasses">
        <template
            v-for="(step, index) in steps"
            :key="index">
            <SbsStep
                :text="step.text"
                :isChecked="step.checked"
                :isDisabled="step.disabled"
                :bulletText="(index + 1).toString()" />
            <div
                v-if="index < steps.length - 1"
                :key="(index + 2) * new Date()"
                class="sbs-stepper__divides">
                <div class="sbs-stepper__divides-dot"></div>
                <div class="sbs-stepper__divides-dot"></div>
            </div>
        </template>
    </div>
</template>

<script>
import 'swiper/swiper-bundle.css';
import themesMixin from '../../mixins/themes.js';
import SbsStep from './SbsStep.vue';

export default {
    name: 'SbsStepper',
    components: {
        SbsStep,
    },
    mixins: [themesMixin],
    data() {
        return {
        };
    },
    computed: {
        stepClasses() {
            const classes = [...this.themeClasses];

            return classes;
        },
    },
    props: {
        steps: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="scss">
.sbs-stepper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 15px 20px;
    overflow: auto;
    background: #f4f5f8;
    border-radius: 10px;

    &__divides {
        display: flex;
        align-items: center;
        margin-right: 5px;

        &-dot {
            width: 3px;
            height: 3px;
            margin-right: 4px;
            background: #d6d9df;
            border-radius: 50%;
        }
    }
}
</style>
